import { AlertTriangle } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { problemMessage } from '@/lib/api/problem'
import { toApiProblem } from '@/lib/api/client'
import { cn } from '@/lib/utils'

export interface ErrorStateProps {
  error: unknown
  onRetry?: () => void
  className?: string
}

/**
 * Failure state for a list or card.
 *
 * Surfaces the correlation id when the backend supplied one, so a user can quote it and
 * support can find the exact server-side trace instead of guessing.
 */
export function ErrorState({ error, onRetry, className }: ErrorStateProps) {
  const problem = toApiProblem(error)

  return (
    <div
      role="alert"
      className={cn('flex flex-col items-center justify-center px-6 py-12 text-center', className)}
    >
      <span className="grid size-12 place-items-center rounded-full bg-[var(--color-tint-red)]">
        <AlertTriangle className="size-6 text-[var(--color-danger)]" aria-hidden="true" />
      </span>
      <p className="mt-3 text-sm font-medium text-[var(--color-heading)]">
        {problemMessage(problem ?? error)}
      </p>
      {problem?.correlationId && (
        <p className="mt-1 font-mono text-xs text-[var(--color-muted)]">
          Reference: {problem.correlationId}
        </p>
      )}
      {onRetry && (
        <Button variant="outline" size="sm" className="mt-4" onClick={onRetry}>
          Retry
        </Button>
      )}
    </div>
  )
}
